export const SALES_CREATE_REQUEST = "SALES_CREATE_REQUEST";
export const SALES_CREATE_SUCCESS = "SALES_CREATE_SUCCESS";
export const SALES_CREATE_FAIL = "SALES_CREATE_FAIL";
export const SALES_CREATE_RESET = "SALES_CREATE_RESET";

export const SALES_DETAILS_REQUEST = "SALES_DETAILS_REQUEST";
export const SALES_DETAILS_SUCCESS = "SALES_DETAILS_SUCCESS";
export const SALES_DETAILS_FAIL = "SALES_DETAILS_FAIL";

export const SALES_UPDATE_REQUEST = "SALES_UPDATE_REQUEST";
export const SALES_UPDATE_SUCCESS = "SALES_UPDATE_SUCCESS";
export const SALES_UPDATE_FAIL = "SALES_UPDATE_FAIL";
export const SALES_UPDATE_RESET = "SALES_UPDATE_RESET";

export const SALES_LIST_REQUEST = "SALES_LIST_REQUEST";
export const SALES_LIST_SUCCESS = "SALES_LIST_SUCCESS";
export const SALES_LIST_FAIL = "SALES_LIST_FAIL";

export const SALES_DELETE_REQUEST = "SALES_DELETE_REQUEST";
export const SALES_DELETE_SUCCESS = "SALES_DELETE_SUCCESS";
export const SALES_DELETE_FAIL = "SALES_DELETE_FAIL";
export const SALES_DELETE_RESET = "SALES_DELETE_RESET";

export const SALES_BATCH_REQUEST = "SALES_BATCH_REQUEST";
export const SALES_BATCH_SUCCESS = "SALES_BATCH_SUCCESS";
export const SALES_BATCH_FAIL = "SALES_BATCH_FAIL";
export const SALES_BATCH_RESET = "SALES_BATCH_RESET";
